module.exports = __webpack_public_path__ + "static/EventsThink-47dbddd9f2b5552bf0b420b875ea4817.png";